$(document).ready(function() {

  const swiper = new Swiper('.swiper', {
      // Optional parameters
      direction: 'horizontal',
      //centeredSlides: true,
      loop: true,

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },

      breakpoints: {
          992: {
            slidesPerView: 2.2,
            spaceBetween: 40,
          },
          0: {
            slidesPerView: 1.1,
            spaceBetween: 30,
          },
      }
  });

});

$(document).ready(function() {

  const swiperPosts = new Swiper('.swiper-posts', {
      // Optional parameters
      direction: 'horizontal',
      //centeredSlides: true,
      loop: true,

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },

      breakpoints: {
          1200: {
            slidesPerView: 3.2,
            spaceBetween: 40,
          },
          992: {
            slidesPerView: 2.2,
            spaceBetween: 40,
          },
          0: {
            slidesPerView: 1.1,
            spaceBetween: 30,
          },
      }
  });

});
